function fn_part_product() {
    var $part = $(".part_product");
}